import React, {useState, useEffect} from "react";

import {Container, Row, Col, Card} from 'react-bootstrap';

import KlettLogo from '../assets/img/logo_header.jpg';

const FooterComponent = () => {

  const [cookie, setCookie] = useState()

  const setCookieInfoHide = () => {
    localStorage.setItem("hideCookie", true);
    setCookie(false)
  }

  let cookieInfo = "";
  
  useEffect(() => {
    if(localStorage.getItem("hideCookie") === undefined || localStorage.getItem("hideCookie") === null || localStorage.getItem("hideCookie") === false && cookie !== true){
      setCookie(true);
    }
  })

  if(cookie){
    cookieInfo =  <Container className="py-lg-3 py-2 text-lg-start text-center">
        <Row className="mt-4">
        <Col sm={12} md={12} lg={12} >
          <Card className="cookieInfo">
            <Card.Body>
              <strong>Ważne: Strona wykorzystuje pliki cookie</strong><br/>
              W ramach naszej witryny stosujemy pliki cookies w celu świadczenia Państwu usług na najwyższym poziomie, w tym w sposób dostosowany do indywidualnych potrzeb. Korzystanie z witryny bez zmiany ustawień dotyczących cookies oznacza, że będą one zamieszczane w Państwa urządzeniu końcowym. Możecie Państwo dokonać w każdym czasie zmiany ustawień dotyczących cookies. Więcej szczegółów w naszej "Polityce Cookies".
              <br/><button onClick={() => setCookieInfoHide()} className="btn btn-xs btn-primary">Zamknij</button>
            </Card.Body>
          </Card>
        </Col>
    </Row>
    </Container>
  }
     
  


  return(
    <React.Fragment>
      {cookieInfo}
      <footer>
        <Container className="py-lg-3 py-2 text-lg-start text-center">
          
          <Row>
            <Col className="col-xl-3 col-lg-4 col-6">
              <a href="https://klett.pl" target="_blank" rel="noopener noreferrer">
                <img src={KlettLogo} alt="Klett Polska sp. z o.o." />
              </a>
            </Col>
            <Col className="d-none d-lg-block text-end pt-2 col-xl-9 col-lg-8">
              <a href="https://klett.pl/polityka-cookies" target="_blank" rel="noopener noreferrer">Polityka Cookies</a>
              <a href="https://klett.pl/regulamin-ksiegarni" target="_blank" rel="noopener noreferrer">Regulamin</a>
              <a href="https://klett.pl/polityka-prywatnosci" target="_blank" rel="noopener noreferrer">Polityka prywatności</a>
              <a href="https://klett.pl/kontakt" target="_blank" rel="noopener noreferrer">Kontakt</a>
            </Col>
          </Row>

        </Container>
      </footer>
    </React.Fragment>
  )
}

export default FooterComponent;